/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goal_Faster_SInputs */

const en_funnel_ob_goal_faster_s = /** @type {(inputs: Funnel_Ob_Goal_Faster_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear your reading list in less time`)
};

const es_funnel_ob_goal_faster_s = /** @type {(inputs: Funnel_Ob_Goal_Faster_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despeja tu lista de lectura en menos tiempo`)
};

/**
* | output |
* | --- |
* | "Clear your reading list in less time" |
*
* @param {Funnel_Ob_Goal_Faster_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goal_faster_s = /** @type {((inputs?: Funnel_Ob_Goal_Faster_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goal_Faster_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goal_faster_s(inputs)
	return en_funnel_ob_goal_faster_s(inputs)
});